<div class="spinner-border" role="status" [ngStyle]="{'color': color}">
  <span class="visually-hidden">Loading...</span>
</div>
